<!--suppress ALL -->
<script lang="ts">
	import {Component, Prop, Extend, Mixin} from 'annotation';
	import {Pie, mixins} from 'vue-chartjs'
	import {cloneDeep, isNil} from 'lodash';
	import {getDistinctPalette} from '@/config/ChartTheme';

	@Component
	export default class PieChart extends Mixin(mixins.reactiveProp) {

		@Prop({default: []})
		public labels: Array<string>;

		@Prop({required: true})
		public datas: Array<any>;

		@Prop({default: {}})
		public options: Object;

		public afterCreated: boolean;

		@Extend
		public extend() {
			return Pie
		}

		public get properties() {
			return [this.datas, this.labels];
		}

		public mounted() {
			this.afterCreated = true;
			this.createChart();
		}

		public get datasets() {
			const {datas} = this;

			return cloneDeep(datas).map((item) => {
				// automaticaly sets bgColor if there is no bg color or if it's a single color for multiple data points
				if (isNil(item.backgroundColor)) {
					item.backgroundColor = getDistinctPalette(item.data.length);
				} else if (Array.isArray(item.backgroundColor) && item.backgroundColor.length < item.data.length) {
					// If provided background color array is too short, generate a full distinct palette
					item.backgroundColor = getDistinctPalette(item.data.length);
				}

				return item;
			});
		}

		public get chartData() {
			const {labels, datasets} = this;

			return {labels, datasets};
		}

		public createChart() {
			const {chartData, options} = this;
			const tooltipOptions = {
				tooltips: {
					callbacks: {
						title: function (tooltipItem, data) {
							return data['labels'][tooltipItem[0]['index']];
						},
						label: function (tooltipItem, data) {
							const total = data['datasets'][0]['data'].reduce((accu: number, item: number) => accu + item, 0);
							const current = data['datasets'][0]['data'][tooltipItem['index']];
							const percent = (current / total) * 100;

							return `${Math.round(percent * 100) / 100}%`;
						}
					}
				}
			}

			this.renderChart(chartData, Object.assign(tooltipOptions, options));
		}
	}
</script>
